<template>
  <component :is="tag" v-bind="$attrs" v-on="$listeners" class="kvass-line">
    <div v-if="hasFilter" class="kvass-line__filter">
      <slot name="filter" />
    </div>
    <div v-if="hasContent" class="kvass-line__content">
      <slot name="content" />
    </div>
    <div v-if="hasDimensions" class="kvass-line__labels kvass-line__labels__column">
      <slot name="dimensions" />
    </div>
  </component>
</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  computed: {
    hasFilter() {
      return this.$slots.filter
    },
    hasContent() {
      return this.$slots.content
    },
    hasDimensions() {
      return this.$slots.dimensions
    },
  },
}
</script>

<style lang="scss">
.kvass-line {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  &__filter {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 1rem;
  }

  &__content {
    display: flex;
    height: auto;
    position: relative;
    justify-content: center;
    align-items: center;

    > div:not(.kvass-line__center) {
      position: relative;
      width: 100%;
    }
  }

  &__labels {
    align-self: center;

    ul {
      list-style: none;
      padding-left: 0;
    }

    &__row {
      margin-left: 1rem;
    }

    &__column {
      margin-top: 1rem;
      align-self: flex-start;
      ul {
        display: flex;
        gap: 0.5rem;
        flex-wrap: wrap;
        max-width: 400px;
      }
    }
    li {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }

  &__bg-label {
    width: 16px;
    height: 16px;
    position: relative;
    display: inline-block;
    border-radius: 100%;
  }

  &__chart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 1rem;
    height: 100%;
    position: relative;
  }
}
</style>
